import { Routes, Route } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "./page/dashboard";
import LoginWithOTP from "./page/LoginWithOTP";
import AdminUsers from "./page/adminList";
import Layout from "./component/layout";
import SubAdminList from "./page/subAdminList";
import BoothPramukh from "./page/boothPramukh";

import SpeakAndSearch from "./page/speakAndSearch";
import BoothWiseVoters from "./page/boothWiseVoters";
import BoothWiseSearch from "./page/boothWiseSearch";
import PollingLocationWiseVoters from "./page/pollingLocationWiseVoters";
import PollingLocationWiseSearch from "./page/pollingLocationWiseSearch";
import MasterSearch from "./page/masterSearch";
import AgeWiseSearch from "./page/ageWiseSearch";
import BoothPramukhDetail from "./page/boothPramukhDetailWithVoters";
import ShaktiKendraList from "./page/saktiKendra";
import Volunteers from "./page/volunteer";
import VoterListMenu from "./page/VoterListMenu";
import CallSurveyList from "./page/CallSurveyList";
import SurnameWise from "./page/SurnameWise";
import SurnameWiseVoters from "./page/SurnameWiseVoters";
import QuickSearch from "./page/quickSearch";
import BoothPramukhOfSaktikendra from "./page/boothPramukhBySaktiKendra";
import SurveyDashboard from "./page/caderWiseSurvey";
import UserWiseSurvey from "./page/userWiseSurvey";
import BoothWiseSurvey from "./page/boothWiseSurvey";
import CastWiseSurvey from "./page/castWiseSurvey";
import CommunityWiseSurvey from "./page/communityWiseSurvey";
import RationCardWiseSurvey from "./page/rationCardWiseSurvey";
import SchemeWiseSurvey from "./page/schemeWiseSurvey";
import PhonebookWiseSurvey from "./page/phonebookWiseSurvey";
import DateWiseSurvey from "./page/dateWiseSurvey";
import BoothPramukhWiseSurvey from "./page/boothPramukhaWiseSurvey";
import SaktiKendraWiseSurvey from "./page/saktiKendraWiseSurvey";
import ScrollToTop from "./component/ScrollToTop";
import MyGroup from "./page/myGroup";
import Phonebook from "./page/phonebook";
import SurnameGroup from "./page/surnameGroup";
import VolunteersPhonebook from "./page/volunteerPhonebook";
import BoothWisePhonebook from "./page/relativeVoterList";
import BoothVoters from "./page/boothWiseRelativeVoter";
import VolunteersSurnameGroup from "./page/volunteerSurnameGroup";
import VolunteersGroup from "./page/volunteersGroup";
import UserSurveyDetails from "./page/userWiseSuveyVoters";
import BoothWiseSurveyVoter from "./page/boothWiseSurveyVoter";
import CastWiseSurveyVoter from "./page/castWiseSurveyVoters";
import CommunityWiseSurveyVoter from "./page/communityWiseSurveyVoter";
import DateWiseSurveyVoters from "./page/dateWiseSurveyVoter";
import RationCardWiseSurveyVoters from "./page/rationCarWiseSurveyVoter";
import ShiftedOutVoterSurvey from "./page/shiftedOutVoterSurvey";
import DeathSurveyVoters from "./page/deathSurveyVoters";
import PhonebookWiseSurveyVoters from "./page/phonebookSurveyVoters";
import SlipDashboard from "./page/slipSendingReport";
import ScanId from "./page/ScanId";
import PhonebookWiseSlipReportDash from "./page/phonebookWiseSlipSendingReport";
import StarVolunteer from "./page/starKarykarta";
import BoothWiseSlipSendDash from "./page/slipSendingReports/boothWiseSlipSendDash";
import PhonebookWiseSlipSendDash from "./page/slipSendingReports/phoonebookWiseSlipSendingDash";
import PhonebookWiseSlipSendVoters from "./page/slipSendingReports/phonebookWiseSlipSendingVoters";
import WalletDashboard from "./page/wallet/walletDashboard";
import UserWalletList from "./page/wallet/UserWalletList";
import PollingLocationDashboard from "./page/slipSendingReports/pollingLocatinWiseSlipSendDash";
import DateWiseSlipSendDash from "./page/slipSendingReports/dateWiseSlipSendDash";
import VolunteerWiseSlipSendDash from "./page/slipSendingReports/volunteerWiseSlipSendDash";
import BluetoothScanner from "./page/priterTest";
import SchemeVoterList from "./page/SchemeVoterList";
import PollingLocationVoters from "./page/slipSendingReports/pollingLocationWiseSlipSendVoter";
import BoothWiseSlipSendVoters from "./page/slipSendingReports/boothWiseSlipSendVoters";
import DateWiseSlipSendingVoters from "./page/slipSendingReports/dateWiseSlipSendVoters";
import MasterSearchSlip from "./page/slipSendingReports/masterSearchSlipSendVoter";
import MySlipSendingVoters from "./page/slipSendingReports/mySlipSendVoters";
import VolunteersSlipSendingVoters from "./page/slipSendingReports/volunteerWiseSlipSendVoters";
import CallCenterSurveyDashboard from "./page/callCenterSurveyReport/mainDashboard";
import BoothWiseCallCenterSurveyDash from "./page/callCenterSurveyReport/bootWiseCallSurveyDash";
import CallCenterSurveyMember from "./page/callCenterSurveyReport/boothWiseCallSurveyVoters";
import DateWiseCallCenterSurveyDash from "./page/callCenterSurveyReport/dateWiseCallSurveyDash";
import DateWiseCallCenterSurveyMember from "./page/callCenterSurveyReport/dateWiseCallSurveyVoters";
import UserWiseCallCenterSurveyDash from "./page/callCenterSurveyReport/callCenterWiseCallSurveyDash";
import UserWiseCallCenterSurveyMember from "./page/callCenterSurveyReport/callCenterWiseCallSurveyVoters";
import PracharMasterDashboard from "./page/pracharMaster/dashboard";
import PhotoPromotion from "./page/pracharMaster/photoPromotion";
import VideoPromotion from "./page/pracharMaster/videoPromotion";
import SlipPromotion from "./page/pracharMaster/slipPromotion";
import PrinterPromotion from "./page/pracharMaster/printerPhotoPromotion";
import SelfiePromotion from "./page/pracharMaster/selfiePromotion";
import TextPromotion from "./page/pracharMaster/textPromotion";
import AudioPromotion from "./page/pracharMaster/audioPromotion";


function App() {
  return (
      <Routes>
      
      <Route path="/" element={<LoginWithOTP />} />
    <Route element={<Layout/>}>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<ProtectedRoute><AdminUsers/></ProtectedRoute>}/>
      <Route path="/sub_admin" element={<ProtectedRoute><SubAdminList/></ProtectedRoute>}/>
      <Route path="/booth_pramukh" element={<ProtectedRoute><BoothPramukh/></ProtectedRoute>}/>
      <Route path="/speak_and_search" element={<ProtectedRoute><SpeakAndSearch/></ProtectedRoute>}/>
      <Route path="/display_total_booth" element={<ProtectedRoute><BoothWiseVoters/></ProtectedRoute>}/>
      <Route path="/booth_wise_search" element={<ProtectedRoute><BoothWiseSearch/></ProtectedRoute>}/>
      <Route path="/display_polling_location_wise_voters" element={<ProtectedRoute><PollingLocationWiseVoters/></ProtectedRoute>}/>
      <Route path="/polling_location_wisesearch" element={<ProtectedRoute><PollingLocationWiseSearch/></ProtectedRoute>}/>
      <Route path="/master_search" element={<ProtectedRoute><MasterSearch/></ProtectedRoute>}/>
      <Route path="/age_wise_search" element={<ProtectedRoute><AgeWiseSearch/></ProtectedRoute>}/>
      <Route path="/booth_pramukh_detail_with_voters" element={<ProtectedRoute><BoothPramukhDetail/></ProtectedRoute>}/>
      <Route path="/dis_saktikendra" element={<ProtectedRoute><ShaktiKendraList/></ProtectedRoute>}/>
      <Route path="/display_karyakarta" element={<ProtectedRoute><Volunteers/></ProtectedRoute>}/>
      <Route path="/voter_list" element={<ProtectedRoute><VoterListMenu/></ProtectedRoute>}/>
      <Route path="/dis_call_center_user" element={<ProtectedRoute><CallSurveyList/></ProtectedRoute>}/>
      <Route path="/dis_all_surname" element={<ProtectedRoute><SurnameWise/></ProtectedRoute>}/>
      <Route path="/surname_wise_voters" element={<ProtectedRoute><SurnameWiseVoters/></ProtectedRoute>}/>
      <Route path="/quick_search" element={<ProtectedRoute><QuickSearch/></ProtectedRoute>}/>
      <Route path="/scan_id" element={<ProtectedRoute><ScanId/></ProtectedRoute>}/>
      <Route path="/booth_pramukh_saktikendra" element={<ProtectedRoute><BoothPramukhOfSaktikendra/></ProtectedRoute>}/>
      <Route path="/dis_survey_dash_for_admin" element={<ProtectedRoute><SurveyDashboard/></ProtectedRoute>}/>
      <Route path="/dis_user_wise_survey_dash" element={<ProtectedRoute><UserWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_booth_wise_survey_dash" element={<ProtectedRoute><BoothWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_cast_wise_survey_dash" element={<ProtectedRoute><CastWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_community_wise_survey_dash" element={<ProtectedRoute><CommunityWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_ration_card_wise_survey_dash" element={<ProtectedRoute><RationCardWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_scheme_wise_survey_dash" element={<ProtectedRoute><SchemeWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_phonebook_wise_survey_dash" element={<ProtectedRoute><PhonebookWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_date_wise_survey_dash" element={<ProtectedRoute><DateWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_booth_pramukh_wise_survey_dash" element={<ProtectedRoute><BoothPramukhWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_sakti_kendra_wise_survey_dash" element={<ProtectedRoute><SaktiKendraWiseSurvey/></ProtectedRoute>}/>
      <Route path="/dis_my_group_member" element={<ProtectedRoute><MyGroup/></ProtectedRoute>}/>
      <Route path="/dis_contact_group_member" element={<ProtectedRoute><Phonebook/></ProtectedRoute>}/>
      <Route path="/dis_surname_group" element={<ProtectedRoute><SurnameGroup/></ProtectedRoute>}/>
      <Route path="/dis_all_contact_match_admin" element={<ProtectedRoute><VolunteersPhonebook/></ProtectedRoute>}/>
      <Route path="/dis_booth_wise_phonebook" element={<ProtectedRoute><BoothWisePhonebook/></ProtectedRoute>}/>
      <Route path="/dis_booth_wise_phonebook_member" element={<ProtectedRoute><BoothVoters/></ProtectedRoute>}/>
      <Route path="/display_surname_match_admin" element={<ProtectedRoute><VolunteersSurnameGroup/></ProtectedRoute>}/>
      <Route path="/dis_user_list_by_create_group" element={<ProtectedRoute><VolunteersGroup/></ProtectedRoute>}/>
      <Route path="/dis_user_wise_survey_voter" element={<ProtectedRoute><UserSurveyDetails/></ProtectedRoute>}/>
      <Route path="/dis_booth_wise_survey_voter" element={<ProtectedRoute><BoothWiseSurveyVoter/></ProtectedRoute>}/>
      <Route path="/dis_cast_wise_survey_voter" element={<ProtectedRoute><CastWiseSurveyVoter/></ProtectedRoute>}/>
      <Route path="/dis_commuinity_wise_survey_voter" element={<ProtectedRoute><CommunityWiseSurveyVoter/></ProtectedRoute>}/>
      <Route path="/dis_date_wise_survey_voter" element={<ProtectedRoute><DateWiseSurveyVoters/></ProtectedRoute>}/>
      <Route path="/dis_ration_card_wise_survey_voter" element={<ProtectedRoute><RationCardWiseSurveyVoters/></ProtectedRoute>}/>
      <Route path="/dis_shifted_out_voter" element={<ProtectedRoute><ShiftedOutVoterSurvey/></ProtectedRoute>}/>
      <Route path="/dis_death_voter" element={<ProtectedRoute><DeathSurveyVoters/></ProtectedRoute>}/>
      <Route path="/dis_phonebook_wise_survey_voter" element={<ProtectedRoute><PhonebookWiseSurveyVoters/></ProtectedRoute>}/>
      <Route path="/get_total_slip_distribution_count" element={<ProtectedRoute><SlipDashboard/></ProtectedRoute>}/>
      {/* <Route path="/phonebook_wise_slip_sending" element={<ProtectedRoute><PhonebookSlipSending/></ProtectedRoute>}/> */}
      <Route path="phonebook_wise_slip_sending_dash" element={<ProtectedRoute><PhonebookWiseSlipReportDash/></ProtectedRoute>}/>
      <Route path="/dis_star_karykarta" element={<ProtectedRoute><StarVolunteer/></ProtectedRoute>}/>
      <Route path='/dis_booth_wise_slip_send_dash' element={<ProtectedRoute><BoothWiseSlipSendDash/></ProtectedRoute>}/>
      <Route path='/dis_phonebook_wise_slip_send_dash' element={<ProtectedRoute><PhonebookWiseSlipSendDash/></ProtectedRoute>}/>
      <Route path='/phonebook_wise_slip_sending' element={<ProtectedRoute><PhonebookWiseSlipSendVoters/></ProtectedRoute>}/>
      <Route path='/dis_wtsp_msg_admin_dash' element={<ProtectedRoute><WalletDashboard/></ProtectedRoute>}/>
      <Route path='/dis_wtsp_user_wallets' element={<ProtectedRoute><UserWalletList/></ProtectedRoute>}/>
      <Route path='/dis_polling_location_wise_slip_send_dash' element={<ProtectedRoute><PollingLocationDashboard/></ProtectedRoute>}/>
      <Route path='/dis_date_wise_slip_distribution' element={<ProtectedRoute><DateWiseSlipSendDash/></ProtectedRoute>}/>
      <Route path='/dis_user_wise_slip_distribution' element={<ProtectedRoute><VolunteerWiseSlipSendDash/></ProtectedRoute>}/>
      <Route path='/printer' element={<BluetoothScanner/>}/>
      <Route path='/dis_scheme_wise_survey_voter' element={<ProtectedRoute><SchemeVoterList/></ProtectedRoute>}/>
      <Route path='/polling_location_wise_slip_sending_voter' element={<ProtectedRoute><PollingLocationVoters/></ProtectedRoute>}/>
      <Route path='/booth_wise_slip_sending' element={<ProtectedRoute><BoothWiseSlipSendVoters/></ProtectedRoute>}/>
      <Route path='/date_wise_slip_sending_voter' element={<ProtectedRoute><DateWiseSlipSendingVoters/></ProtectedRoute>}/>
      <Route path='/master_search_for_slip_send' element={<ProtectedRoute><MasterSearchSlip/></ProtectedRoute>}/>
      <Route path='/dis_my_slip_sending_voter' element={<ProtectedRoute><MySlipSendingVoters/></ProtectedRoute>}/>
      <Route path='/volunteers_slip_send_voters' element={<ProtectedRoute><VolunteersSlipSendingVoters/></ProtectedRoute>}/>
      <Route path='/dis_admin_call_center_survey_dashboard' element={<ProtectedRoute><CallCenterSurveyDashboard/></ProtectedRoute>}/>
      <Route path='/dis_booth_wise_call_center_survey_dash' element={<ProtectedRoute><BoothWiseCallCenterSurveyDash/></ProtectedRoute>}/>
      <Route path='/dis_booth_wise_call_center_survey_voter' element={<ProtectedRoute><CallCenterSurveyMember/></ProtectedRoute>}/>
      <Route path='/dis_date_wise_call_center_survey_dash' element={<ProtectedRoute><DateWiseCallCenterSurveyDash/></ProtectedRoute>}/>
      <Route path='/dis_date_wise_call_center_survey_voter' element={<ProtectedRoute><DateWiseCallCenterSurveyMember/></ProtectedRoute>}/>
      <Route path='/dis_user_wise_call_center_survey_dash' element={<ProtectedRoute><UserWiseCallCenterSurveyDash/></ProtectedRoute>}/>
      <Route path='/dis_user_wise_call_center_survey_voter' element={<ProtectedRoute><UserWiseCallCenterSurveyMember/></ProtectedRoute>}/>
      <Route path='/prachar_master' element={<ProtectedRoute><PracharMasterDashboard/></ProtectedRoute>}/>
      <Route path='/photo_promotion' element={<ProtectedRoute><PhotoPromotion/></ProtectedRoute>}/>
      <Route path='/video_promotion' element={<ProtectedRoute><VideoPromotion/></ProtectedRoute>}/>
      <Route path='/slip_promotion' element={<ProtectedRoute><SlipPromotion/></ProtectedRoute>}/>
      <Route path='/printer_photo_promotion' element={<ProtectedRoute><PrinterPromotion/></ProtectedRoute>}/>
      <Route path='/selfie_promotion' element={<ProtectedRoute><SelfiePromotion/></ProtectedRoute>}/>
      <Route path='/text_promotion' element={<ProtectedRoute><TextPromotion/></ProtectedRoute>}/>
      <Route path='/audio_promotion' element={<ProtectedRoute><AudioPromotion/></ProtectedRoute>}/>
      </Route>
    </Routes>
  );
}

export default App;
